import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ForwardButton, BackButton, DisplayErrors } from "./Survey.jsx";

class AddLink extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errors: []
        };

        this.removeArticle = this.removeArticle.bind(this);
        this.LinkChangeHandler = this.LinkChangeHandler.bind(this);
    }

    LinkChangeHandler(e, props) {
        props.LinkChangeHandler(e, props);
    }

    removeArticle(e, props) {
        props.removeArticle(e, props);
    }
    
    render() {
        return (
            <div className="row collapse upload-field-container">
                <input type = "text"  name="answer[]" id="answer" key={this.props.response.ID} defaultValue={this.props.response.Answer} placeholder="Add Link" className="url upload-field" onChange={(e) => this.LinkChangeHandler(e, this.props)} />
                <a id = "remove-article-button" onClick={(e) => this.removeArticle(e, this.props)}>
                    <i className="fa fa-times" aria-hidden="true"></i>
                </a>
            </div>
        );
    }
}


const mapStateToProps = store => ({
    userSession: store.userSession
})

export default connect(mapStateToProps,)(AddLink);